import { api } from "../api/client";

// Local mock-quote store. Used when the API isn't reachable so the
// order-sheet flow can be exercised end-to-end in dev / before NetSuite
// is wired up. Remove once `api.createQuote` is live.
function localQuoteCreate(payload) {
  const id = `LQ-${Date.now().toString(36)}`;
  const quote = {
    id,
    status: "draft",
    createdAt: new Date().toISOString(),
    items: payload?.items || [],
    meta: payload?.meta || {},
  };
  try {
    const raw = sessionStorage.getItem("mr.b2b.localQuotes");
    const all = raw ? JSON.parse(raw) : [];
    all.push(quote);
    sessionStorage.setItem("mr.b2b.localQuotes", JSON.stringify(all));
  } catch { /* quota */ }
  return quote;
}

async function withMock(promise, fallback) {
  try {
    const out = await promise;
    if (out && (out.id || out.items)) return out;
    return fallback();
  } catch {
    return fallback();
  }
}

export const QuoteController = {
  list() { return api.listQuotes(); },
  get(id) { return api.getQuote(id); },
  create(payload) {
    return withMock(api.createQuote(payload), () => localQuoteCreate(payload));
  },
  submit(id) { return api.submitQuote(id); },

  // Quote-to-cash convenience: submit, convert to SO, then create Bolt cart.
  async checkout(quoteId) {
    await api.submitQuote(quoteId);
    const order = await api.convertQuoteToOrder(quoteId);
    const bolt = await api.createBoltCart(quoteId);
    return { order, bolt };
  },
};
